<div class="checkout-group">
  <div class="checkout-group-title">
    {{ 'checkout.group.payment.title' | cxTranslate }}
  </div>
  <div class="checkout-group-body d-flex">
    <ng-container *ngIf="b2bUnitServiceDetails$ | async as paymentDetails">
      <div class="payment-group-info">
        <span class="payment-title">{{ 'checkout.group.payment.paymentModeTitle' | cxTranslate }}</span>
        <span class="payment-value">{{ paymentDetails.paymentMode }}</span>
      </div>
      <div class="payment-group-info">
        <span class="payment-title">{{ 'checkout.group.payment.paymentModeTerms' | cxTranslate }}</span>
        <span class="payment-value">{{
          'checkout.group.payment.paymentModeTermsInDays' | cxTranslate : { termsUnit: paymentDetails.paymentTerms }
        }}</span>
      </div>
    </ng-container>
  </div>
</div>
